namespace SPA
{
	export namespace Realtor2
	{
		export namespace New
		{
			export class Benefit extends Guide.GuideContent
			{

				private m_Form: ui.Form.Form;

				public constructor( private m_Obj: Realtor2.NewObject )
				{
					super();

					this.m_Form = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => { return; }
						}
					);
				}

				public build( root: ui.base.BaseHTMLElement ): void
				{
					new ui.base.BaseHTMLElement( 'h2' )
						.text( 'Erträge' )
					.appendTo( root );
				}

				protected buildNavigation( nav: ui.base.BaseHTMLElement ): void
				{
					new ui.base.Button(
						$('<i class="fas fa-arrow-circle-left"></i> <span>Zurück</span>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel ) { this.m_Panel.MovePrev(); }
								}
							}
						}
					).rebuild( nav );

					new ui.base.Button(
						$('<span>Weiter</span> <i class="fas fa-arrow-circle-right"></i>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel )
									{
										if ( this.m_Obj.checkForm( this.m_Form ) )
										{
											this.m_Panel.MoveNext();
										}
									}
								}
							}
						}
					).rebuild( nav );
				}

			}
		}
	}
}
